import {BaseCriteriaModel} from '../base-criteria.model';
import {Optional} from 'typescript-optional';

export class MerchantEventQueryCriteriaClass extends BaseCriteriaModel {
  hdr_guid?: Optional<string> = Optional.empty();
  ext_guid?: Optional<string> = Optional.empty();
  line_guid?: Optional<string> = Optional.empty();
  link_guid?: Optional<string> = Optional.empty();

  txn_type?: Optional<string> = Optional.empty();
  date_txn?: Optional<string> = Optional.empty();
  obj_action?: Optional<string> = Optional.empty();
  event_code?: Optional<string> = Optional.empty();

  created_date?: Optional<string> = Optional.empty();
  updated_date?: Optional<string> = Optional.empty();
}

export class MerchantEventCriteriaModelQuery {
  query = '';

  constructor(merchantEventCriteriaModel: MerchantEventQueryCriteriaClass) {
    console.log('merchantEventCriteriaModel', merchantEventCriteriaModel);

    if (!merchantEventCriteriaModel) {
      return;
    }

    this.query += merchantEventCriteriaModel.hdr_guid.filter(x => x !== '').map(x => '&hdr_guid=' + x).orElse('');
    this.query += merchantEventCriteriaModel.ext_guid.filter(x => x !== '').map(x => '&ext_guid=' + x).orElse('');
    this.query += merchantEventCriteriaModel.line_guid.filter(x => x !== '').map(x => '&id_user=' + x).orElse('');
    this.query += merchantEventCriteriaModel.link_guid.filter(x => x !== '').map(x => '&id_device=' + x).orElse('');

    this.query += merchantEventCriteriaModel.txn_type.filter(x => x !== '').map(x => '&txn_type=' + x).orElse('');
    this.query += merchantEventCriteriaModel.date_txn.filter(x => x !== '').map(x => '&date_txn=' + x).orElse('');
    this.query += merchantEventCriteriaModel.obj_action.filter(x => x !== '').map(x => '&obj_action=' + x).orElse('');

    this.query += merchantEventCriteriaModel.event_code.filter(x => x !== '').map(x => '&event_code=' + x).orElse('');
    this.query += merchantEventCriteriaModel.created_date.filter(x => x !== '').map(x => '&created_date=' + x).orElse('');
    this.query += merchantEventCriteriaModel.updated_date.filter(x => x !== null).map(x => '&updated_date=' + x).orElse('');


    this.query += '&status=' + merchantEventCriteriaModel.status;
    this.query += '&orderBy=' + merchantEventCriteriaModel.orderBy;
    this.query += '&order=' + merchantEventCriteriaModel.order;
    this.query += '&offset=' + merchantEventCriteriaModel.offset + '&limit=' + merchantEventCriteriaModel.limit;
  }

}
